import CommunityOnboardingSteps from "./CommunityOnboardingSteps";

export default CommunityOnboardingSteps;